export default function getDimensionsWithinBounds(
  nodeWidth,
  nodeHeight,
  resolutionScale,
  maxDimension = 320
) {
  let width = nodeWidth
  let height = nodeHeight

  // Calculate based on optional DPI.
  if (typeof resolutionScale === 'number') {
    if (typeof width === 'number') {
      width = width * resolutionScale
    }
    if (typeof height === 'number') {
      height = height * resolutionScale
    }
  }

  // Only interested in pixel ratio scaling when it is greater than or equal to 2x
  // We also don't want to scale already large images.
  if (window.devicePixelRatio && window.devicePixelRatio >= 2) {
    if (
      typeof width === 'number' &&
      typeof height === 'number' &&
      width <= maxDimension &&
      height <= maxDimension
    ) {
      width = width * 2
      height = height * 2
    }
  }

  return {
    width,
    height,
  }
}
